import React from 'react'

const DealerPowerMoreLoans = () => {
  return (
    <section id="c-sectionPowerMoreLoans" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Power more loans with AI-powered financing</h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-8 col-md-12">						
						<p className="c-para22Regular">Fi-men allows you to collaborate with many lending institutions at once</p>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-5 col-lg-6 col-12 c-powerMoreLoansImgCol">				
					<img src="images/dealer/power_more_loans.png" className="img-fluid" alt="" title="" />
				</div>
				<div className="col-md-7 col-lg-6 col-12">
					<div className="c-powerMoreLoansStatsWrapper">
						<div className="c-pmlStatRow">
							<div className="c-pmlStatIcon">
								<img src="./images/dealer/pml_reserve_rates.png" alt="" title="" />
							</div>
							<div className="c-pmlStatInfo">
								<div className="c-pmlStatTitle">Get higher loan approvals</div>
								<div className="c-pmlStatPercent">
									{/* <!-- <span>3%</span> --> */}
									<div className="c-clear"></div>
									<div className="c-pmlStatUpto">Up to 80%</div>
								</div>								
							</div>
						</div>
						<div className="c-pmlStatRow">
							<div className="c-pmlStatIcon">
								<img src="./images/dealer/pml_increase_advance.png" alt="" title="" />
							</div>
							<div className="c-pmlStatInfo">
								<div className="c-pmlStatTitle">High seller rate with success</div>
								<div className="c-pmlStatPercent">
									{/* <!-- <span>185%</span> --> */}
									<div className="c-clear"></div>
									<div className="c-pmlStatUpto">Up to 185%</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</section>
  )
}

export default DealerPowerMoreLoans